<template>
  <div v-if="history">
    <div>
      <v-dialog
        v-model="dialog"
        persistent
        transition="dialog-bottom-transition"
        width="1000"
      >
        <!--begin::Modal dialog-->
        <div class="bg-white poppins min-h-100">
          <!--begin::Modal header-->
          <div class="modal-header py-4 align-center">
            <h4 class="mb-0 font-weight-bolder">{{ type }} history</h4>
            <!--begin::Close-->
            <div
              class="btn btn-sm btn-icon btn-active-light-info"
              @click="dialog = false"
            >
              <span class="svg-icon">
                <v-icon size="22">mdi-close</v-icon>
              </span>
            </div>
            <!--end::Close-->
          </div>
          <!--begin::Modal header-->
          <!--begin::Modal body-->
          <div class="modal-body d-flex flex-column scroll-y mx-5 py-7">
            <!--begin::Body-->
            <div class="row ma-0">
              <div class="col-12">
                <div class="px-2 mb-4 d-flex align-items-center">
                  <span class="font-weight-medium h6 mb-0 poppins py-1 me-3"
                    >Previous data:</span
                  >
                </div>

                <div class="custom-rule-select">
                  <v-autocomplete
                    v-model="history.before"
                    :label="$t('selected_countries')"
                    :items="history.before"
                    item-text="text"
                    return-object
                    outlined
                    clearable
                    multiple
                    small-chips
                    deletable-chips
                    hide-details
                  />
                </div>
              </div>

              <div class="col-12">
                <div class="px-2 mb-4 d-flex align-items-center">
                  <span class="font-weight-medium h6 mb-0 poppins py-1 me-3"
                    >Current data:</span
                  >
                </div>

                <div class="custom-rule-select">
                  <v-autocomplete
                    v-model="history.after"
                    :label="$t('selected_countries')"
                    :items="history.after"
                    item-text="text"
                    return-object
                    outlined
                    clearable
                    multiple
                    small-chips
                    deletable-chips
                    hide-details
                  />
                </div>
              </div>
            </div>
            <!--end::Body-->
            <!--begin::Actions-->
            <div
              class="my-4 h-75px d-flex flex-grow-1 align-end justify-center"
            >
              <button
                type="submit"
                class="btn btn-info px-5 py-3 ls1"
                @click="approveShipmentType"
              >
                Approve
              </button>
            </div>
            <!--end::Actions-->
          </div>
          <!--end::Modal body-->
        </div>
        <!--end::Modal dialog-->
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";

export default {
  name: "LastHistory",
  props: ["loadRulesFromServer", "approveStatusId"],
  data: () => ({
    dialog: false,
    shipmentType: false,
    history: null,
    type: null,
  }),
  methods: {
    approveShipmentType() {
      Swal.fire({
        title: "Warning",
        text: "You are going to approve this rule, continue?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.commit(SET_PAGE_LOADING, true);
          ApiService.post(
            "/order_management/order_management_simplified_rules/status",
            { status: this.approveStatusId, id: this.shipmentType.rule_id }
          )
            .then(({ data }) => {
              if (data.success) {
                this.loadRulesFromServer();
                Swal.fire({
                  title: "Approved",
                  text: "Rule is successfully approved!",
                  icon: "success",
                });
              }
              this.dialog = !this.dialog;
            })
            .finally(() => {
              this.$store.commit(SET_PAGE_LOADING, false);
            });
        }
      });
    },
    toggleModal(shipmentType, history, type) {
      this.shipmentType = shipmentType;
      this.history = history;
      this.type = type;
      this.dialog = !this.dialog;
    },
  },
};
</script>
